import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { api } from "../api";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";

const Haberler = () => {
  const [items, setItems] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.news().then(setItems).catch(() => {});
  }, []);

  return (
    <main className="bg-white">
      <SEO title={t("news.title")} description={t("news.subtitle")} path="/haberler" />
      <PageHero kicker={t("news.kicker")} title={t("news.title")} subtitle={t("news.subtitle")} />

      <section className="pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 grid sm:grid-cols-2 gap-4 md:gap-6">
          {items.map((n) => (
            <Link
              key={n.id}
              to={`/haberler/${n.id}`}
              className="group rounded-2xl overflow-hidden border border-neutral-100 bg-white hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-shadow duration-300 flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden bg-neutral-100">
                <img
                  src={n.image}
                  alt={n.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="text-xs uppercase tracking-[0.2em] text-[#C9A24B] font-semibold">{n.date}</div>
                <h3 className="mt-2 text-xl md:text-2xl font-black text-[#1a1a1a] leading-tight group-hover:text-[#8F6E1E] transition-colors">
                  {n.title}
                </h3>
                <p className="mt-3 text-neutral-600 text-[15px] leading-relaxed">{n.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-2 self-start text-sm font-semibold text-[#1a1a1a] group-hover:text-[#C9A24B] transition-colors">
                  {t("common.readMore")} <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Haberler;
